import { render, staticRenderFns } from "./CadastroBase.vue?vue&type=template&id=7757f3ff"
import script from "./CadastroBase.vue?vue&type=script&lang=js"
export * from "./CadastroBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports